export const CEFR_LEVEL_ORDER = ["A1", "A2", "B1", "B2", "C1", "C2"];

export const titleize = (value) =>
  value
    .replace(/[_-]+/g, " ")
    .split(" ")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const getReadingMinutes = (wordCount) => Math.max(Math.ceil(wordCount / 150), 1);

export const getNextStory = (stories, current) => {
  const sameLevel = stories
    .filter((story) => story.cefrLevel === current.cefrLevel)
    .sort((a, b) => a.title.localeCompare(b.title));
  if (sameLevel.length < 2) return null;
  const currentIndex = sameLevel.findIndex((story) => story.id === current.id);
  return sameLevel[(currentIndex + 1) % sameLevel.length];
};

export const requestJson = (options) =>
  new Promise((resolve, reject) => {
    $.ajax({ dataType: "json", ...options }).done(resolve).fail(reject);
  });

export const goTo = (url) => {
  window.location.href = url;
};

const EXTRA_DICTIONARIES = {
  de: { name: "dict.cc", url: (query) => `https://www.dict.cc/?s=${query}` },
  es: { name: "SpanishDict", url: (query) => `https://www.spanishdict.com/translate/${query}` },
  ja: { name: "Jisho", url: (query) => `https://jisho.org/search/${query}/` }
};

// Same dictionaries as the old Cloze Reading word popover.
export const getDictionaryLinks = ({ baseLanguageCode, baseLanguageIso, targetLanguageCode, targetLanguageIso, targetLanguageName, word }) => {
  const query = encodeURI(word);
  const extra = EXTRA_DICTIONARIES[targetLanguageIso];
  return [
    { name: "Google Translate", url: window.clozemaster.getGoogleTranslateUrl(targetLanguageIso, baseLanguageIso, word) },
    { name: "Forvo", url: `https://forvo.com/search/${query}/` },
    { name: "Wiktionary", url: `https://en.wiktionary.org/wiki/${query}#${targetLanguageName}` },
    { name: "Tatoeba", url: `https://tatoeba.org/eng/sentences/search?from=${targetLanguageCode}&to=${baseLanguageCode}&query=${query}` },
    ...(extra ? [{ name: extra.name, url: extra.url(query) }] : [])
  ];
};
